export const MIN_CONSENTS_FOR_DOWNLOAD_ALL = 2;
export const MA_AGENDY = false;
